import { defineComponent as _defineComponent } from 'vue'
import ExpandableModal from "@/components/shared/modal/ExpandableModal.vue";
import BusStopInfoSimple from "@/components/line/BusStopInfoSimple.vue";

import SwiperCore, { EffectCoverflow, Navigation, Pagination } from "swiper";
import "swiper/swiper.scss";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import { ref, computed, PropType } from "vue";
import { IBusStopData } from "@/domain/entities/busStop";
import calculateDistance from "@/use/useCalculateDistance";
import { ILineInfoLite } from "@/domain/entities/lineInfo";
import LineInfoList from "@/components/line/LineInfoList.vue";


const __default__ = {
  name: "MapOfNearbyBusStopsBottomSheet",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  busStops: {
    type: Array as PropType<IBusStopData[]>,
    required: true,
  },
  selectedBusStop: {
    type: Object as PropType<IBusStopData>,
    required: true,
  },
  updateKey: {
    type: Number,
    default: 0,
  },
  lineInfos: {
    type: Array as PropType<ILineInfoLite[]>,
    required: true,
  },
  maxHeightPx: {
    type: Number,
    default: window.innerHeight * 0.8,
  },
  initalIndex: {
    type: Number,
    default: 0,
  },
},
  emits: ["onSlideChange", "onChangedShowLineInfoList"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const shouldShowLineInfoList = ref(false);
const expandableModalRef = ref();

const toggleShowLineInfoList = (isExpanded: boolean) => {
  shouldShowLineInfoList.value = isExpanded;
  emit("onChangedShowLineInfoList", isExpanded);
};

const handleContentHeightChange = (height: number) => {
  if (
    expandableModalRef.value &&
    expandableModalRef.value.handleContentHeightChange
  ) {
    expandableModalRef.value.handleContentHeightChange(height);
  }
};

const handleShowAllLineInfoList = () => {
  expandableModalRef.value.setExpanded(true);
  toggleShowLineInfoList(true);
};

SwiperCore.use([EffectCoverflow, Navigation, Pagination]);

const currentIndex = ref(props.initalIndex);
const updateCurrentIndex = (index: number) => {
  currentIndex.value = index;
};

const swiperInstance = ref();
const hasMultipleBusStops = computed(() => props.busStops.length > 1);
const baseHeightPx = computed(() => {
  // pagination이 있을 때: 165px (기존)
  // pagination이 없을 때: 145px (165 - 64 + 24 = 125px)
  // 64px: 기존 bottom padding, 24px: 새 bottom padding
  // return hasMultipleBusStops.value ? 165 : 145;

  return 165;
});

const swiperOptions = computed(() => {
  const hasMultiple = hasMultipleBusStops.value;

  return {
    // wrapper 클래스
    class: "card-swiper",

    // 사용할 모듈
    modules: [Navigation, Pagination],

    // 한 번에 보여줄 슬라이드 개수
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    initialSlide: currentIndex.value,

    // 슬라이드 개수가 1 초과일 때만 loop 활성화
    loop: hasMultiple,

    pagination: hasMultiple
      ? {
          el: ".swiper-pagination",
          type: "fraction" as const,
          renderFraction: function (currentClass: string, totalClass: string) {
            return `
          <div style="font-family: 'Pretendard', sans-serif; font-size: 12px; margin-bottom: 24px;">
            <span class="pagination-nav prev-slide" style="cursor: pointer; padding: 8px 12px;">&lt;</span>
            <span style="margin: 0 4px;">
              <span class="${currentClass}" style="font-weight: bold;"></span><span style="font-weight: bold;">&nbsp;/&nbsp;</span><span class="${totalClass}"></span>
            </span>
            <span class="pagination-nav next-slide" style="cursor: pointer; padding: 8px 12px;">&gt;</span>
          </div>
        `;
          },
          clickable: true,
        }
      : false,

    // 좌우 네비게이션 버튼
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
  };
});
const onSlideChange = (swiper: SwiperCore) => {
  updateCurrentIndex(swiper.realIndex);
  emit("onSlideChange", props.busStops[swiper.realIndex]);
};

const onSwiper = (swiper: SwiperCore) => {
  swiperInstance.value = swiper;
  setTimeout(() => {
    const prevButton = document.querySelector(".pagination-nav.prev-slide");
    const nextButton = document.querySelector(".pagination-nav.next-slide");

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        swiperInstance.value?.slidePrev();
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        swiperInstance.value?.slideNext();
      });
    }
  }, 100); // 요소가 DOM에 렌더링될 시간을 주기 위한 짧은 지연
};

const movePreviousBusStop = () => {
  swiperInstance.value?.slidePrev();
};

const moveNextBusStop = () => {
  swiperInstance.value?.slideNext();
};

const getDistanceMeter = (
  busStop: IBusStopData,
  lat: number,
  lng: number
): number => {
  return (
    calculateDistance(busStop.latitude, busStop.longitude, lat, lng) * 1000
  );
};

__expose({
  movePreviousBusStop,
  moveNextBusStop,
  swiperInstance,
});

const __returned__ = { props, emit, shouldShowLineInfoList, expandableModalRef, toggleShowLineInfoList, handleContentHeightChange, handleShowAllLineInfoList, currentIndex, updateCurrentIndex, swiperInstance, hasMultipleBusStops, baseHeightPx, swiperOptions, onSlideChange, onSwiper, movePreviousBusStop, moveNextBusStop, getDistanceMeter, ExpandableModal, BusStopInfoSimple, get Swiper() { return Swiper }, get SwiperSlide() { return SwiperSlide }, LineInfoList }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})